import { featureFlags } from "@/contexts/CdpProvider";
import { useEffect, useState } from "react";
import { getFeaturesFlagsFromQuery } from "../getFeaturesFlags";
export function useFeatureFlagVariant(flagName, variant) {
    const [featuresFlagsFromQuery, setFeaturesFlagsFromQuery] = useState();
    useEffect(() => {
        var _a;
        setFeaturesFlagsFromQuery(getFeaturesFlagsFromQuery((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.search));
    }, []);
    const mergedFlags = Object.assign(Object.assign({}, featureFlags), featuresFlagsFromQuery);
    return (mergedFlags === null || mergedFlags === void 0 ? void 0 : mergedFlags[flagName]) === variant;
}
